import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { faqs, PHONE, PHONE_TEL } from "../mock";

const FAQ = () => (
  <section id="faq" className="bg-[#ece9f8] py-24">
    <div className="max-w-4xl mx-auto px-5 lg:px-8">
      <p className="reveal text-xs font-semibold tracking-[0.22em] uppercase text-[#7c3aed] mb-4">
        Good To Know
      </p>
      <h2 className="reveal font-display text-4xl lg:text-5xl font-semibold text-[#1e183a] leading-tight">
        Frequently asked questions.
      </h2>
      <p className="reveal mt-5 text-[#1e183a]/65 leading-relaxed">
        Still unsure about something? Call our free helpline on{" "}
        <a href={`tel:${PHONE_TEL}`} className="text-[#7c3aed] font-semibold hover:underline">
          {PHONE}
        </a>{" "}
        and a friendly UK advisor will explain everything.
      </p>

      <div className="reveal mt-10">
        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="rounded-2xl bg-white border border-[#1e183a]/8 px-6 data-[state=open]:border-[#7c3aed]/40"
            >
              <AccordionTrigger className="text-left font-display text-lg font-semibold text-[#1e183a] hover:no-underline py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-[#1e183a]/65 leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  </section>
);

export default FAQ;
